<template>
	<div class="row">
		<div class="cell">{{ product.title }}</div>
		<div v-if="!product.single_variant" class="cell"><a href @click.prevent="$emit('variants', product)" class="link">{{ numVariants }} Variant{{ numVariants !== 1 ? 's' : '' }}</a></div>
		<div v-if="product.single_variant" class="cell">No Variants</div>
		<div class="cell">{{ priceRange }}</div>
		<div class="cell"><span v-for="category in visibleCategories" :key="`product-${ product.id }-category-${ category }`" class="tag brand-bg">{{ category }}</span></div>
		<div class="cell align-right buttons">
			<delete-button @deleted="(done) => $emit('delete', { product, done })">
				<router-link :to="`/commerce/products/${ product.id }/edit`" class="button"><div class="hover-title">Update</div><span class="fa fa-pencil"></span></router-link>
			</delete-button>
		</div>
	</div>
</template>

<script>

import DeleteButton from '@/views/components/DeleteButton';

export default {

	props: {
		product: {
			type: Object,
			required: true
		}
	},

	computed: {

		numVariants() {
			return Object.values(this.product.variants).length;
		},

		visibleCategories() {
			if (this.product.categories.length <= 3) {
				return this.product.categories;
			}

			const categories = [ ...this.product.categories ].slice(0, 2);
			categories.push(`+${ this.product.categories.length - 2 } More`);

			return categories;
		},

		priceRange() {
			let prices = Object.values(this.product.variants).map(price => parseFloat(price));
			let min = Math.min(...prices);
			let max = Math.max(...prices);

			if (min === max) {
				return '$' + min.toFixed(2);
			}

			return `$${ min.toFixed(2) } - $${ max.toFixed(2) }`;
		}

	},

	components: {
		DeleteButton,
	},
};

</script>
